<template>
    <div class="shopify-message">
        <div class="image-stack">
            <div
                class="image-stack__image"
                v-for="product in order.products"
                :key="product.product_id"
            >
                <img :src="product.image.src" />
            </div>
        </div>

        <div class="content">
            <span class="title" v-if="order.products.length === 1"
                >A painting was sold!</span
            >
            <span class="title" v-else
                >{{ order.products.length }} painting sold!</span
            >
            <span class="subtitle">Visit artbymaddy.com</span>
        </div>
    </div>
</template>

<script>
import "@/assets/custom/maddy/typography.scss";

export default {
    props: ["order"],
    name: "ShopifyMessage",
};
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
    transition: transform 1s ease-in-out;
}
.v-enter, .v-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translateX(-100%);
}

.shopify-message {
    background: #112935;
    display: inline-flex;
    flex-direction: column;
    border-radius: 0 8px 8px 0;
    margin-top: 75px;
    padding-left: 16px;
    padding-right: 32px;
}

.content {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
}

.content .title {
    font-family: "Monly", sans-serif;
    font-size: 48px;
    color: #fff;
}

.content .subtitle {
    color: #d7cf72;
}

.image-stack {
    display: flex;
    flex-direction: row;
    transform: translateY(-50%);
    margin-bottom: calc(-50% + 50px);

    &__image {
        padding: 3px;
        background: white;
        display: inline-flex;
        align-self: center;

        &:nth-child(1) {
            transform: rotate(5deg);
        }

        &:nth-child(2) {
            transform: translateX(-25%) rotate(-5deg);
        }

        img {
            max-height: 120px;
            max-width: 125px;
            align-self: center;
        }
    }
}
</style>
